module.exports = __webpack_public_path__ + "media/application/images/footer-arrow-b2e00ebc7275eb248ba152581ab528b8.svg";